<template>
  <div>
    <Bar text="费用确认"></Bar>
    <div class="e-flex jc-center">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="150px"
      >
        <el-form-item label="投标保证金（万元）" prop="guaranteeAmount">
          <el-input-number
            v-model="form.guaranteeAmount"
            @change="handleCalcAmount"
            :min="0.0001"
            :max="80"
            :step="10"
            label="请输入投标保证金（万元）"
            :disabled="isHlj"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="保函费用" prop="productAmount">
          <div class="text-red fw-6 fs-md">
            {{ productAmount }}
          </div>
        </el-form-item>
       <!-- <el-tooltip class="item" effect="light" content="招标文件中要求通过基本户支付保函费，或者要求交款人与递交投标文件单位名称一致，请勾选“是”" placement="bottom-start"> -->
        <el-form-item label="支付方式选择" prop="basicPay" v-show="!hidePaymentType">
          <el-radio-group v-model="form.basicPay">
            <el-radio :label="'1'">公对公转账</el-radio>
            <el-radio :label="'0'">在线支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- </el-tooltip> -->
         <el-form-item label="选择担保机构" prop="partnerId" v-if="!isCqsw">
          <el-select v-model="form.partnerId" placeholder="请选择" @change="handleSelect">
            <el-option v-for="item in form.partnerList" :key="item.id" :label="item.channelPartnerShowName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="isHlj">
          <el-form-item label="银行账户户名" prop="bankCardName">
            <el-input v-model="form.bankCardName" maxlength="200"/>
          </el-form-item>
          <el-form-item label="银行账户号码" prop="bankCardNo">
            <el-input v-model="form.bankCardNo" maxlength="50"/>
          </el-form-item>
        </template>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="form.remarks" />
        </el-form-item>
        <el-form-item label="选择出函平台" prop="processingAccess" v-if="isCqsw" >
          <div class="image-group" >
            <el-image v-for="(item, index) in processingAccessList" :label="item.code" :key="index" :class="{
              'image-item': true,
              'image-selected': processingAccess === item.code
            }" :src='item.icon' fit="fill" @click="clickProcessingAccess(item)"></el-image>
          </div>
          <span style="color: red;" v-if="isCqswV6">收费标准均为担保金额的0.48%</span>
          <span style="color: red; display: block; line-height: 1.6;" v-if="processingAccess === 'zcjf'">
            招采金服客服电话：4006166620转3<br>
            保函小秘书手机号（同微信）：18202189350
          </span>
        </el-form-item>
        <el-form-item v-if="invoiceTipMsg && !isCqsw" label="开票须知" prop="invoiceTip">
          <el-checkbox size="mini" v-model="form.invoiceTip">
            {{ invoiceTipMsg }}
          </el-checkbox>
        </el-form-item>
        <el-form-item v-if="showGuaranteeApply" label="保函申请书" prop="guaranteeApply">
          <el-checkbox size="mini" v-model="form.guaranteeApply">
            我已知悉并承诺遵守
             <span class="link-blue" @click="openGuaranteeApply">《投标保函申请书》</span>
             条款
          </el-checkbox>
        </el-form-item>
        <el-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <el-button @click="gopage"> 上一步 </el-button>
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="onSubmit"> 确认 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { fiterData } from '../../../util/dataForma'
import { calculateInsurance, submitElectronic, queryPartnerRegionByPartnerId, queryChanelByPcd, createGuaranteeApply } from '../../../api/comm'
import bar from '../projectBar/bar'
import { mapMutations, mapState, LETTER } from '../../../store/modules/letter'
import { cloneDeep, debounce } from 'lodash'
import { isLogin, showLogin } from '@/shared/user'
import { formatArea } from '@/shared/location'
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import { GetApiCodeById } from '@/shared/type'
import { t } from 'vxe-table'
import { download } from '@/shared/file'
import { ORDER_TYPE, saveCurrentDraft, clearCurrentDraft } from '@/shared/guaranteeDraft'

export default {
  data() {
    const validatorProductAmount = (rule, value, cb) => {
      if (!this.form.productAmount) {
        return cb(new Error('获取金额失败请联系客服'))
      }
      cb()
    }
    const validatorGuaranteeAmount = (rule, value, cb) => {
      if (!this.form.guaranteeAmount) {
        return cb(new Error('请填写保证金额'))
      }
      if (/\.\d{5,}$/.test('' + this.form.guaranteeAmount)) {
        return cb(new Error('金额只保留小数点后4位'))
      }
      cb()
    }

    return {
      hidePaymentType: false,
      draftSaving: false,
      form: {
        guaranteeApply: '',
      },
      productAmount: '',
      processingAccess: 'zcjf',
      invoiceTipMsg: null,
      isSystemDock: null,
      showGuaranteeApply: false,
      attr2: null,
      rules: {
        productAmount: [
          {
            required: true,
            validator: validatorProductAmount,
          },
        ],
        guaranteeAmount: [
          {
            required: true,
            validator: validatorGuaranteeAmount,
          },
        ],
        tenderCompanyName: [
          { required: true, message: '请填写招标人全称', trigger: 'change' },
        ],
        openingDate: [
          { required: true, message: '请选择开标时间', trigger: 'change' },
        ],
        province: [
          { required: true, message: '请选择项目地区', trigger: 'change' },
        ],
        processingAccess: [
          { required: true, message: '请选择出函平台', trigger: 'change' },
        ],
        basicPay: [
          {
            required: true,
            message: '请选择支付方式',
            trigger: 'change',
          },
        ],
        bankCardNo: [
          {
            required: true,
            message: '请输入银行账户号码',
            trigger: 'blur'
          }
        ],
        bankCardName: [
          {
            required: true,
            message: '请输入银行账户户名',
            trigger: 'blur'
          }
        ],
        partnerId: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.partnerId) {
              callback()
            } else {
              callback(new Error('请选择担保机构'))
            }
          },
        },
        invoiceTip:[
          { required: true,
          validator: (_, v, cb) => {
            if (this.form.invoiceTip) {
              cb()
            } else {
              cb(new Error('请勾选同意开票须知'))
            }
          }, trigger: 'change' },
        ],
        guaranteeApply:[
          { required: true,
          validator: (_, v, cb) => {
            if (this.form.guaranteeApply) {
              cb()
            } else {
              cb(new Error('请勾选同意《投标保函申请书》'))
            }
          }, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      formStorage: 'guarantee',
    }),
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isCqswV6() {
      return this.isCqsw && this.form.apiId == 'cqsw_v6'
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
    processingAccessList() {
      const baseList = [
        {
          partnerId: null,
          code: 'zcjf',
          isSystemDock: '0',
          icon: require('@/assets/platform/def.jpg'),
          attr2: null,
        }
      ]
      if (this.isCqswV6) {
        baseList.push({
          partnerId: 41,
          code: 'lysk',
          isSystemDock: '1',
          icon: require('@/assets/platform/lysk.jpg'),
          attr2: '您已选择链云平台出具保函，后续支付、开票等操作由链云平台为您提供服务。如有疑问，请咨询：（400-028-5975）。请确定是否进入链云平台。',
        })
      }
      if (this.form.partnerList && this.form.partnerList.length > 0) {
        baseList[0].partnerId = this.form.partnerList[0].id
      } else if (baseList[0] && this.form.partnerId && this.form.processingAccess === 'zcjf') {
        baseList[0].partnerId = this.form.partnerId
      }
      return baseList
    }
  },
  components: {
    Bar: bar,
  },
  methods: {
    ...mapMutations({
      guarantee: LETTER.GUARANTEE,
      clear: LETTER.CLEAR,
    }),
    changeBasicPay(val) {
      if (val === '0') {
        this.form.bankCardNo = ''
        this.form.bankCardName = ''
      }
    },
    openLoading() {
      return this.$loading({ lock: true, text: 'Loading' })
    },
    handleSelect(e) {
     const partnerInfo = this.form.partnerList.find((i) => i.id === e)
     this.initPartner(partnerInfo)
     this.calcAmount()
    },
    initPartner(partnerInfo){
       const chargeProductType = partnerInfo?.chargeProductType
       const accountNo = partnerInfo?.accountNo
       this.form.partnerName = partnerInfo?.channelPartnerName
       this.form.partnerId = partnerInfo?.id
      const isNeedCommitment = partnerInfo?.isNeedCommitment
      const paymentType = partnerInfo?.paymentType
      const hidePaymentType = partnerInfo?.hidePaymentType
      this.showGuaranteeApply = true
      if (isNeedCommitment) {
        if (isNeedCommitment == '0') {
          this.form.isNeedCommitment = false
        } else if (isNeedCommitment == '1') {
          this.form.isNeedCommitment = true
          this.showGuaranteeApply = false
        }
      }
      if (paymentType) {
        this.form.paymentType = paymentType
        this.$set(this.form, 'basicPay', paymentType)
      }
      if (hidePaymentType &&hidePaymentType == '1') {
        this.hidePaymentType = true
      }else{
        this.hidePaymentType = false
      }
      if (accountNo != undefined && chargeProductType != undefined && chargeProductType.includes('9600')) {
        this.form.isAgencyFees = true
      } else {
        this.form.isAgencyFees = false
      }
      this.attr2 = partnerInfo?.attr2
      this.invoiceTipMsg = partnerInfo?.attr1
      this.isSystemDock = partnerInfo?.isSystemDock
      this.$set(this.form, 'isOtiPlat', this.isSystemDock === '1');
      this.queryOrgPayment()
      this.$forceUpdate()
    },
    clearPartner(){
       this.form.partnerName = null
       this.form.partnerId = null
       this.form.isNeedCommitment = null
       this.form.paymentType = null
       this.form.isAgencyFees = null
       this.form.guaranteeApply = false
       this.invoiceTipMsg = null
       this.isSystemDock = null
       this.attr2 = null
       this.$forceUpdate()
    },
    queryOrgPayment() {
      const { province, district, city, partnerId } = this.form
      queryPartnerRegionByPartnerId({
        channelPartnerId: partnerId,
        province: province,
        city: city,
        district: district,
      }).then((res) => {
        if (res.data) {
          this.hidePaymentType = true
          this.$set(this.form, 'basicPay', '1')
          this.$forceUpdate()
        }
      })
    },
    queryChanelPartner(){
    const { province, district, city, apiName,apiId,tenderCompanyName,partnerId, projectCode, bidderCompanyName, projectSource, sourceRadio, guaranteeAmount } = this.form
    if (province && district && city) {
      queryChanelByPcd({ province, district, city, apiName,apiId,tenderCompanyName, projectCode, bidderCompanyName, projectSource, sourceRadio, guaranteeAmount }).then((res) => {
        this.form.partnerList = cloneDeep(res.data)
        if(partnerId){
          const defaultData = this.form.partnerList.filter( (val) => val.id == partnerId )
          if(defaultData && defaultData.length>0){
              this.initPartner(defaultData[0])
            }else{
              this.clearPartner()
            }
        }else if(this.isCqsw || this.isHlj){
          this.initPartner(this.form.partnerList[0])
        }
        this.$forceUpdate()
      })
    }
    },
    calcAmount() {
      if (!this.form.guaranteeAmount) return
       this.loadingAmount = true
       if(this.form.apiAccessConfigId && !this.form.apiId){
        this.form.apiId = GetApiCodeById(this.form.apiAccessConfigId)
       }
      calculateInsurance({
        productType: '9600',
        guaranteeAmount: Number((this.form.guaranteeAmount * 10000).toFixed(0)),
        apiId: this.$route.path.includes('anhui')
          ? 'ahyd': this.$route.path.includes('guizhouBank')
          ?'gzyh': this.form.apiId,
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        outerOrderNo: this.$route.query.outerOrderNo,
        orderId: this.$route.query.orderID,
        projectSource: this.form.projectSource,
        sourceRadio: this.form.sourceRadio,
        partnerId: this.form.partnerId
      }).then((res) => {
        this.loadingAmount = false
        this.form.productAmount = res.data.productPrice + res.data.servicePrice
        this.productAmount = res.data.totalAmount
        this.$forceUpdate()
      })
    },
    handleCalcAmount: debounce(function () {
      this.form.partnerId = null
      this.queryChanelPartner()
      this.calcAmount()
    }, 200),
    gopage() {
      this.$emit('changeIndex', 1)
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.ELECTRONIC_9600, 2, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    onSubmit() {
        if (!isLogin()) {
        showLogin()
        return false
      }
      if(!this.processingAccess && this.isCqsw){
        this.$message.error('请选择出函平台')
        return
      }
      this.guarantee(this.form)
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const form = { ...this.form }
        form.orderType = '9600'
        if (!this.$route.query.orderID) {
          form.orderId = null
        }

        const can = { ...this.form }
        await fiterData(can)
        can.basicPay = can.basicPay == '0' ? '在线支付' : '公对公转账'
        if (!this.isHlj) {
          delete can.bankCardNo
          delete can.bankCardName
        }
        console.log('can', can)
        can.rojectArea = formatArea(can.rojectArea)
        this.$showAffirm(can, '9600').then(() => {
          if (this.isSystemDock == '1') {
            this.submitOtiElectronic(form)
          } else {
            this.submitElectronic(form)
          }
        })
      })
    },
    submitOtiElectronic(form) {
      this.$confirm(
        this.attr2,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      ).then(() => {
        this.submitElectronic(form)
      }).catch(() => {
      });
    },
    submitElectronic(form) {
      const loading = this.openLoading()
      const { province, district, city } = form
      const isNeedCommitment = this.form.isNeedCommitment
      submitElectronic(form).then((res) => {
        loading.close()
        form.orderId = res.data.orderId
        this.clear()
        // 提交成功，清空 Redis 草稿
        clearCurrentDraft(this, ORDER_TYPE.ELECTRONIC_9600)
        if (form.isOtiPlat) {
          window.open(res.data.url, "_blank");
          this.$router.push({
            path: '/orderDetail',
            query: {
              order: form.orderId,
            },
          })
        } else {
          let data = {
            pdfID: res.data.electronicPdfFileId,
            province: province,
            district: district,
            city: city,
            orderId: res.data.orderId,
            isNeedCommitment: isNeedCommitment,
          }
          this.$router.push({
            name: 'letterCmmmit',
            query: {
              ...data,
            },
          })
        }

      }).catch(() => {
        loading.close()
      })
    },
    openGuaranteeApply() {
      const loading = this.openLoading()
      const params = {
        partnerName: this.form.partnerName,
        bidderCompanyName: this.form.bidderCompanyName,
        tenderCompanyName: this.form.tenderCompanyName,
        projectName: this.form.projectName,
        projectCode: this.form.projectCode,
        totalAmount: this.productAmount,
        money: String(this.form.guaranteeAmount * 10000),
      }
      createGuaranteeApply(params).then((res) => {
        loading.close()
        const fileId = res.data
        if (fileId) {
          download(fileId)
        } else {
          this.$message.error('获取保函申请书失败')
        }
      }).catch(() => {
        loading.close()
      })
    },
    clickProcessingAccess(item) {
      this.processingAccess = item.code
      this.$set(this.form, 'isOtiPlat', item.isSystemDock === '1');
      this.attr2 = item.attr2
      this.$set(this.form, 'partnerId', item.partnerId);
      this.$set(this.form, 'processingAccess', item.code);
      this.isSystemDock = item.isSystemDock
    },
    init(data) {
      // 父组件显式覆盖数据 —— init 后业务逻辑也要跑（和 created 里保持一致）
      this.form = cloneDeep(data || {})
      this._initFromForm()
    },
    _initFromForm() {
      if (this.form.guaranteeAmount) {
        this.form.guaranteeAmount = Number(this.form.guaranteeAmount)
        this.calcAmount()
      }
      if (this.form.isAgencyFees) {
        this.hidePaymentType = true
        this.$set(this.form, 'basicPay', '1')
      }
      const { province, district, city, partnerId } = this.form
      if (this.isCqsw) {
        const firstItem = this.processingAccessList?.[0] ?? null;
        const matchedItem = partnerId
          ? this.processingAccessList.find(item => item.partnerId === partnerId)
          : null;
        const defData = matchedItem ?? firstItem;
        this.$set(this.form, 'isOtiPlat', defData.isOtiPlat);
        this.$set(this.form, 'partnerId', defData.partnerId);
        this.$set(this.form, 'processingAccess', defData.code);
        this.processingAccess = defData ? defData.code : 'zcjf'
      }
      this.$set(this.form, 'bankCardNo', this.form.bankCardNo);
      this.$set(this.form, 'bankCardName', this.form.bankCardName);
      this.queryChanelPartner()
    }
  },
  created() {
    // step 切换恢复：从 Vuex letter.guarantee 读
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    this._initFromForm()
  },

}

</script>
<style scoped lang="less">
.link-blue {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #66b1ff;
  }
}

.image-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.image-item {
  height: 100px;
  /* 图片高度（与宽度搭配保持比例） */
  cursor: pointer;
  transition: all 0.25s ease;
  border: 2px solid transparent;
  border-radius: 6px;
  overflow: hidden;

  ::v-deep img {
    width: 100%;
    height: 100%;
    object-fit: inherit;
  }
}

.image-item:hover {
  border-color: #F56C6C;
  box-shadow: 0 0 12px rgba(255, 64, 128, 0.3);
  transform: translateY(-2px);
}

.image-selected {
  border-color: #F56C6C;
  box-shadow: 0 0 6px rgba(255, 64, 128, 0.3);
  background-color: rgba(24, 144, 255, 0.08);
}
</style>